export enum UomConversionAuditColId {
  ALTERNATE_SALES_UOM = 'alternateSalesUom',
  ALTERNATE_UOM = 'alternateUom',
  BASE_UOM = 'baseUom',
  EXTERNAL_UOM = 'externalUom',
  EXTRACTED_UOM = 'extractedUom',
  LINE_COUNT = 'lineCount',
  MANUFACTURER = 'manufacturer',
  PACKAGE_UOM = 'packageUom',
  PART_DESCRIPTION = 'partDescription',
  PART_NUMBER = 'partNumber',
  PURCHASE_COST_UOM = 'purchaseCostUom',
  QUOTE_IDS = 'quoteIds',
  SALES_UOM = 'salesUom',
  SKU_UOM = 'skuUom',
  STATUS = 'conversionToBase',
}
